$(document).ready(function () {
  $('.home-saying-slides').slick({
    centerMode: true,
    slidesToShow: 3,
    variableWidth: true,
  })
})
